import React from 'react';
import { Rail } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/rail.less';

export default Rail;
